import { type AxiosInstance } from "axios";
import { SALESFORCE_CONNECTION_ENDPOINT } from "@/features/salesforceIntegration/api/getConnection";

/**
 * Salesforceとの連携を解除する（`DELETE /salesforce/connection/`）。
 */
export const deleteConnection = async (
  apiClient: AxiosInstance
): Promise<void> => {
  await apiClient.delete(SALESFORCE_CONNECTION_ENDPOINT);
};
